import { z } from 'zod';
import { IsoTimestamp, UserId } from './common';

export const TriggerStatus = z.enum(['pending', 'claimed', 'consumed', 'expired']);
export type TriggerStatus = z.infer<typeof TriggerStatus>;

/**
 * Trigger source.
 *
 *  - `mobile` / `desktop_manual` — produced by new code (#332).
 *  - `scheduler` — retained as a valid READ value for historical
 *    TRIGGER# rows. NOT accepted by the POST /v1/triggers write
 *    boundary (`apps/api/src/handlers/triggers.ts` constrains the
 *    request body's `source` to `'mobile' | 'desktop_manual'`).
 */
const TriggerSource = z.enum(['mobile', 'desktop_manual', 'scheduler']);

export const Trigger = z.object({
  userId: UserId,
  triggerId: z.string(),
  status: TriggerStatus,
  source: TriggerSource,
  createdAt: IsoTimestamp,
  claimedAt: IsoTimestamp.optional(),
  claimedByDeviceId: z.string().optional(),
  ttl: z.number().int(),
});

export type Trigger = z.infer<typeof Trigger>;

export const CreateTriggerResponse = z.object({
  triggerId: z.string(),
  status: TriggerStatus,
});

export const ClaimTriggerRequest = z.object({
  deviceId: z.string(),
});
